<template>
  <div class="container mt-4 mb-6">
    <div class="text-center" v-if="isLoading">
      <HMSpinner></HMSpinner>
    </div>
    <div v-else>
      <div v-if="signedContract.id && !signedContract.document">
        <SignContractComponent
          :signedContract="signedContract"
          @onContractSigned="loadData"
        />
      </div>
      <div v-else>
        <div class="text-center">
          <h2 class="mb-4">
            {{ $t('CONTRACTS.TITLES.YOUR_SIGNED_CONTRACT') }}
          </h2>
          <HMFilePreview
            v-if="signedContract.document"
            :file="signedContract.document"
          />
          <HMButton color="brand" class="my-4">
            <router-link
              class="undecorated-router-link"
              :to="{ name: 'studio-home-page' }"
            >
              {{ $t('GENERAL.BUTTON.RETURN_TO_STUDIO') }}
            </router-link>
          </HMButton>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import HMSpinner from '@/web/components/common/HMSpinner.vue';
import { errorToMessage } from '../../../core/utils/errors';
import HMFilePreview from '../../components/common/HMFilePreview';
import SignContractComponent from '../../components/contracts/SignContractComponent';

export default {
  name: 'StudentSignContract',
  components: {
    HMFilePreview,
    HMSpinner,
    SignContractComponent,
  },
  data() {
    return {
      isLoading: true,
      signedContract: null,
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      isLoggedIn: 'user/isLoggedIn',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    uuid() {
      return this.$route.params.unique_id;
    },
  },
  methods: {
    async loadData() {
      if (!this.isLoggedIn && !this.uuid) return;
      this.isLoading = true;
      try {
        this.signedContract = await this.$store.dispatch(
          'studio/getSignedContract',
          {
            studioURL: this.studioURL,
            uuid: this.uuid,
          }
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: `Failed to load contract`,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    isLoggedIn: {
      handler() {
        if (this.isLoggedIn) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
};
</script>
